import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <button
      onClick={() => i18n.changeLanguage(current === 'fr' ? 'en' : 'fr')}
      className="px-2 py-1 text-xs font-medium border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
      title={current === 'fr' ? 'Switch to English' : 'Passer en francais'}
    >
      {current === 'fr' ? 'EN' : 'FR'}
    </button>
  );
}
